// ============================================================================
// CONFIGURATION EXPORTS
// ============================================================================
// Centralized exports for all configuration utilities
// ============================================================================

import { default as config } from "./environment";

export { default as config, type EnvironmentConfig } from "./environment";

// Re-export commonly used configuration sections
export const {
  api,
  msal,
  app,
  features,
  debug,
  performance,
  services,
  security,
  deployment,
  localization,
  notifications,
  fileUpload,
  testing
} = config;

// Configuration utilities
export * from "./environment";
